import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState, useCallback } from 'react';
import { useMemo } from 'react';
import { useClickAway } from 'react-use';
import { useMediaQuery } from 'react-responsive';
import { defaultChartThemePreview, themePreviewsMap } from '@/config/theme';
import { getThemeName } from '@/utils/theme';
import { resetSectionConfigStyles } from '@/features/ChartBuilder/utils';
import { colorSchemeBySection } from '@/features/ChartBuilder/configs';
import editorSettings from '@/components/Editor/settings';
import ToolbarMenu from '@/components/ToolbarMenu';
import ClientOnly from '@/components/ClientOnly';
import ChartsSwitcher from '@/components/ChartsSwitcher';
import TemplatesGallery from './Templates';
import ThemesGallery from './Themes';
import GalleryPanel from './Panel';
import DataEditorPanel from './DataEditorPanel';
import ConfirmTemplatePrompt from './ConfirmTemplatePrompt';
import ConfirmThemePrompt from './ConfirmThemePrompt';
import { GalleryPanelEnum, GALLERY_DATA_PANEL_ID, GALLERY_THEME_PANEL_ID, GALLERY_TEMPLATE_PANEL_ID, GALLERY_SIGNUP_PANEL_ID } from '../settings';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CubeIcon = function CubeIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20.0528 10.6056C20.3628 10.4506 20.7309 10.4671 21.0257 10.6494C21.3205 10.8316 21.5 11.1534 21.5 11.5V18C21.5 18.3788 21.286 18.725 20.9472 18.8944L14.9472 21.8944C14.6372 22.0494 14.2691 22.0329 13.9743 21.8507C13.6795 21.6684 13.5 21.3466 13.5 21V14.5C13.5 14.1212 13.714 13.775 14.0528 13.6056L20.0528 10.6056Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.94721 10.6056C4.63723 10.4506 4.26909 10.4671 3.97427 10.6494C3.67945 10.8316 3.5 11.1534 3.5 11.5V18C3.5 18.3788 3.714 18.725 4.05279 18.8944L10.0528 21.8944C10.3628 22.0494 10.7309 22.0329 11.0257 21.8507C11.3205 21.6684 11.5 21.3466 11.5 21V14.5C11.5 14.1212 11.286 13.775 10.9472 13.6056L4.94721 10.6056Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.9472 2.10557C12.6657 1.96481 12.3343 1.96481 12.0528 2.10557L4.05279 6.10557C3.714 6.27496 3.5 6.62123 3.5 7C3.5 7.37877 3.714 7.72504 4.05279 7.89443L12.0528 11.8944C12.3343 12.0352 12.6657 12.0352 12.9472 11.8944L20.9472 7.89443C21.286 7.72504 21.5 7.37877 21.5 7C21.5 6.62123 21.286 6.27496 20.9472 6.10557L12.9472 2.10557Z",
      fill: "#12131A"
    })]
  }));
};

CubeIcon.defaultProps = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ThemesIcon = function ThemesIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.5 9.16667C7.5 8.24619 8.24619 7.5 9.16667 7.5H15.8333C16.7538 7.5 17.5 8.24619 17.5 9.16667V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H9.16667C8.24619 17.5 7.5 16.7538 7.5 15.8333V9.16667Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5 7.5C12.5 10.2614 10.2614 12.5 7.5 12.5C4.73858 12.5 2.5 10.2614 2.5 7.5C2.5 4.73858 4.73858 2.5 7.5 2.5C10.2614 2.5 12.5 4.73858 12.5 7.5Z",
      fill: "#12131A"
    })]
  }));
};

ThemesIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_8838_1619)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 8C18 5.30541 15.8685 3.10867 13.1996 3.00391C12.1627 1.20835 10.2225 0 8 0C5.14631 0 2.75793 1.99223 2.1498 4.66173C0.860197 5.45305 0 6.87607 0 8.5C0 10.9853 2.01472 13 4.5 13H13C15.7614 13 18 10.7614 18 8Z",
        fill: "#C3C9D1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10 17C10 17.5523 9.55228 18 9 18C8.44772 18 8 17.5523 8 17V9.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L8.29289 6.29289C8.68342 5.90237 9.31658 5.90237 9.70711 6.29289L11.7071 8.29289C12.0976 8.68342 12.0976 9.31658 11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711L10 9.41421V17Z",
        fill: "black"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8838_1619",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      })
    })]
  }));
};

UploadIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CrownIcon = function CrownIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_8841_1625)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M2.00049 13H16.0005V17C16.0005 17.5523 15.5528 18 15.0005 18H3.00049C2.4482 18 2.00049 17.5523 2.00049 17V13Z",
        fill: "#C3C9D1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.00872128 2.13694C-0.0702641 1.70613 0.40354 1.38918 0.771584 1.62662L5.54637 4.70708C5.79121 4.86504 6.11872 4.78102 6.25728 4.52469L8.56051 0.263706C8.74952 -0.0859494 9.25122 -0.0859485 9.44022 0.263707L11.7435 4.52469C11.882 4.78102 12.2095 4.86504 12.4544 4.70708L17.2291 1.62662C17.5972 1.38918 18.071 1.70613 17.992 2.13694L16.0004 13H2.00037L0.00872128 2.13694Z",
        fill: "black"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8841_1625",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18.0007",
          height: "18",
          fill: "white"
        })
      })
    })]
  }));
};

CrownIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ViewTableIcon = function ViewTableIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 9.4C3 7.15979 3 6.03968 3.43597 5.18404C3.81947 4.43139 4.43139 3.81947 5.18404 3.43597C6.03968 3 7.15979 3 9.4 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03968 21 7.15979 21 9.4V14.6C21 16.8402 21 17.9603 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C17.9603 21 16.8402 21 14.6 21H9.4C7.15979 21 6.03968 21 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3 17.9603 3 16.8402 3 14.6V9.4Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 16L9 21H11L11 16H21V14H11V10H21V8H11L11 3H9L9 8H3V10H9V14H3V16H9Z",
      fill: "black"
    })]
  }));
};

ViewTableIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartIcon = function ChartIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7784_1436)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.75 2.38357C23.75 0.601579 21.8604 -0.545676 20.2794 0.276373L14.5007 3.28094C14.2435 3.41469 13.9462 3.4497 13.6649 3.37938L10.2509 2.52589C9.65679 2.37736 9.02827 2.46406 8.49656 2.7679L1.19667 6.93926C0.45668 7.36212 0 8.14906 0 9.00134V16.6247C0 17.9364 1.06332 18.9997 2.375 18.9997H21.375C22.6867 18.9997 23.75 17.9364 23.75 16.6247V2.38357Z",
        fill: "#12131A",
        fillOpacity: "0.25"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.4613 11.0771L0.770541 13.9611C0.307055 14.1349 0 14.578 0 15.073V16.6251C0 17.9368 1.06332 19.0001 2.375 19.0001H21.375C22.6867 19.0001 23.75 17.9368 23.75 16.6251V9.5001C23.75 8.67098 22.9219 8.09708 22.1455 8.38821L15.2887 11.4856C14.6123 11.7392 13.8747 11.7812 13.1738 11.606L10.5762 10.9566C9.87533 10.7814 9.13775 10.8234 8.4613 11.0771Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7784_1436",
        children: /*#__PURE__*/_jsx("rect", {
          width: "23.75",
          height: "19",
          fill: "white"
        })
      })
    })]
  }));
};

ChartIcon.defaultProps = {
  width: "24",
  height: "19",
  viewBox: "0 0 24 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const MENU_ITEMS = [{
  icon: /*#__PURE__*/_jsx(CubeIcon, {}),
  title: 'Templates',
  indicator: true,
  id: GalleryPanelEnum.TEMPLATES
}, {
  icon: /*#__PURE__*/_jsx(ThemesIcon, {}),
  title: 'Themes',
  id: GalleryPanelEnum.THEME
}, {
  icon: /*#__PURE__*/_jsx(ViewTableIcon, {}),
  title: 'Data',
  id: GalleryPanelEnum.DATA
}, {
  icon: /*#__PURE__*/_jsx(ChartIcon, {}),
  title: 'Charts',
  id: GalleryPanelEnum.CHARTS
}, {
  icon: /*#__PURE__*/_jsx(UploadIcon, {}),
  title: 'Upload',
  id: GalleryPanelEnum.UPLOAD
}];
const BOTTOM_MENU_ITEMS = [{
  icon: /*#__PURE__*/_jsx(CrownIcon, {}),
  title: 'Signup',
  id: GalleryPanelEnum.SIGNUP
}];
const DEFAULT_GALLER_SETTINGS = {
  templatesEnabled: false,
  dataEditorEnabled: false,
  themeEnabled: false,
  signupEnabled: true
};

const Gallery = _ref => {
  let {
    nameSpace,
    user,
    activeTemplate,
    activeSectionId,
    componentType,
    activePanel,
    templatesTag,
    gallerySettings: defaultGallerySettings,
    galleryBottomMenuActions,
    dataEditorColumnStructure,
    isDataGenerating = false,
    hasDataEditorErrors = false,
    workbookData,
    workbookErrors,
    selectGalleryItem,
    getGoogleDriveFile,
    onChangeGoogleDriveFile,
    onChangeWorkbookData,
    onSelectTemplate,
    onSwitchEditingMode,
    onChange,
    onChangeTheme,
    onFontsChange,
    onAiGenerate,
    onChartSelect,
    onSave
  } = _ref;
  const activeTemplateId = (activeTemplate === null || activeTemplate === void 0 ? void 0 : activeTemplate.id) || '';
  const gallerySettings = useMemo(() => _objectSpread(_objectSpread({}, DEFAULT_GALLER_SETTINGS), defaultGallerySettings), [defaultGallerySettings]); // Media queries

  const isDesktop = useMediaQuery({
    minWidth: editorSettings.twoColumnLayout
  });
  const {
    0: isNestedMenuOpen,
    1: setNestedMenuOpen
  } = useState(false);
  const {
    0: selectedTemplate,
    1: setSelectedTemplate
  } = useState(null);
  const {
    0: selectedTheme,
    1: setSelectedTheme
  } = useState(null); // Close all panels when clicking away

  const containerRef = useRef(null);
  useClickAway(containerRef, () => {
    if (!isDesktop || isNestedMenuOpen) return; // timeout prevents data loss by ensuring state updates complete before panel closes

    setTimeout(() => selectGalleryItem(-1));
  });
  const closeGalleryPanels = useCallback(() => {
    selectGalleryItem(-1);
  }, [selectGalleryItem]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      ref: containerRef,
      className: styles.container,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.gallery,
        children: /*#__PURE__*/_jsxs(ClientOnly, {
          children: [/*#__PURE__*/_jsx(ToolbarMenu, {
            classNames: {
              menu: styles.menu
            },
            direction: !isDesktop ? 'horizontal' : 'vertical',
            items: MENU_ITEMS,
            active: activePanel,
            hiddenItems: {
              [GALLERY_TEMPLATE_PANEL_ID]: !(gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.templatesEnabled),
              [GALLERY_THEME_PANEL_ID]: !(gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.themeEnabled),
              [GALLERY_DATA_PANEL_ID]: !(gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.dataEditorEnabled)
            },
            errorIndicators: {
              [GALLERY_DATA_PANEL_ID]: hasDataEditorErrors || Boolean(workbookErrors === null || workbookErrors === void 0 ? void 0 : workbookErrors.length)
            },
            onChange: selectGalleryItem
          }), galleryBottomMenuActions ?? /*#__PURE__*/_jsx(ToolbarMenu, {
            direction: !isDesktop ? 'horizontal' : 'vertical',
            items: BOTTOM_MENU_ITEMS,
            active: activePanel,
            hiddenItems: {
              [GALLERY_SIGNUP_PANEL_ID]: !(gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.signupEnabled)
            },
            onChange: selectGalleryItem
          })]
        })
      }), GALLERY_TEMPLATE_PANEL_ID === activePanel && gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.templatesEnabled ? /*#__PURE__*/_jsx(ClientOnly, {
        children: /*#__PURE__*/_jsx(GalleryPanel, {
          title: "Templates",
          description: "Select one of these pre-made templates, then customize.",
          isMobile: !isDesktop,
          onClose: closeGalleryPanels,
          isCloseButtonHidden: true,
          children: /*#__PURE__*/_jsx(TemplatesGallery, {
            templatesTag: templatesTag,
            activeTemplateId: activeTemplateId,
            selectedTemplateId: selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.id,
            isPopoverVisible: isDesktop,
            onSelect: template => {
              setSelectedTemplate(template);
            }
          })
        })
      }) : null, GALLERY_THEME_PANEL_ID === activePanel && gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.themeEnabled ? /*#__PURE__*/_jsx(ThemesGallery, {
        nameSpace: nameSpace,
        theme: activeTemplate.config.theme,
        colorPallet: activeTemplate.config.colorPallet,
        palletColorOverrides: activeTemplate.config.palletColorOverrides,
        defaults: colorSchemeBySection[componentType],
        previews: themePreviewsMap[componentType] || defaultChartThemePreview,
        isMobileOrTablet: !isDesktop,
        onClose: closeGalleryPanels,
        onChange: updates => {
          // handle color pallet changes
          if (!updates.theme) {
            onChangeTheme(updates);
            return;
          } // Detect if there are any changes to the section styles


          const result = resetSectionConfigStyles(activeTemplate, activeSectionId);

          if (result !== null && result !== void 0 && result.hasChanges) {
            // Open confirmation prompt
            setSelectedTheme(updates);
          } else {
            onChangeTheme(updates);
          }
        },
        onOverridePalletColors: (name, colors) => onChange('config.palletColorOverrides', {
          [name]: colors
        }),
        onMenuOpenChange: setNestedMenuOpen,
        onLoadFonts: onFontsChange
      }) : null, GALLERY_DATA_PANEL_ID === activePanel && gallerySettings !== null && gallerySettings !== void 0 && gallerySettings.dataEditorEnabled ? /*#__PURE__*/_jsx(DataEditorPanel, {
        nameSpace: `${nameSpace}-data-editor`,
        user: user,
        isMobileOrTablet: !isDesktop,
        isDataGenerating: isDataGenerating,
        workbookData: workbookData,
        workbookErrors: workbookErrors,
        dataEditorColumnStructure: dataEditorColumnStructure,
        selectGalleryItem: selectGalleryItem,
        getGoogleDriveFile: getGoogleDriveFile,
        onChangeGoogleDriveFile: onChangeGoogleDriveFile,
        onAiGenerate: onAiGenerate,
        onChangeWorkbookData: onChangeWorkbookData,
        onSave: onSave,
        onSwitchEditingMode: onSwitchEditingMode,
        onCloseGalleryPanel: closeGalleryPanels
      }) : null, GalleryPanelEnum.CHARTS === activePanel ? /*#__PURE__*/_jsx(GalleryPanel, {
        title: "Charts",
        description: "Try another one of our free, full-featured, chart builders.",
        isMobile: !isDesktop,
        onClose: closeGalleryPanels,
        children: /*#__PURE__*/_jsx(ChartsSwitcher, {
          onChartSelect: onChartSelect
        })
      }) : null]
    }), selectedTemplate ? /*#__PURE__*/_jsx(ConfirmTemplatePrompt, {
      isVisible: Boolean(selectedTemplate),
      templateName: selectedTemplate.title,
      onOpen: () => {
        if (!isDesktop) closeGalleryPanels();
      },
      onClose: () => {
        setSelectedTemplate(null);
      },
      onConfirm: () => {
        onSelectTemplate(selectedTemplate);
        setSelectedTemplate(null);
        closeGalleryPanels();
      }
    }) : null, selectedTheme ? /*#__PURE__*/_jsx(ConfirmThemePrompt, {
      isVisible: true,
      themeName: getThemeName(selectedTheme.theme),
      onOpen: () => {
        if (!isDesktop) closeGalleryPanels();
      },
      onClose: () => {
        setSelectedTheme(null);
      },
      onConfirm: () => {
        const result = resetSectionConfigStyles(activeTemplate, activeSectionId);
        onChangeTheme(selectedTheme, result === null || result === void 0 ? void 0 : result.changes);
        setSelectedTheme(null);
        closeGalleryPanels();
      }
    }) : null]
  });
};

export default Gallery;